import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule,HTTP_INTERCEPTORS} from '@angular/common/http';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SharedModule } from './Shared/shared.module';
import { UserService } from 'src/app/services/User.service';
import { TokenInterceptor} from './Shared/token.interceptor';
import { DatePipe } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import { SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { LicenseTermsComponent } from './license-terms/license-terms.component';

@NgModule({
  declarations: [
    AppComponent,
    LicenseTermsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    PaginationModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ToastrModule.forRoot({preventDuplicates: true}),
    ModalModule.forRoot(),
    SwitchModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    UserService,DatePipe   ,
    { provide: LOCALE_ID, useValue: 'en-US' }  
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
